
export function generateLabel(key: string, item: string) {
    const label = removeSpecialCharacters(item);
    return `${key}.${label.trim().replace(/\s/g, ".").replace("..", ".").toLowerCase()}`;
}

export function removeSpecialCharacters(item: string) {
    return item.replace(/[^a-zA-Z\s]/g, "");
}

